import { z } from "zod";
import { apiIntIdSchema } from "./ids.js";
/** PATCH body limit. Read models do not cap stored names so a backfill can round-trip. */
export const PLATFORM_ENDPOINT_LOCAL_NAME_MAX_LENGTH = 200;
export const updatePlatformEndpointLocalNameRequestSchema = z.object({
    localName: z.string().trim().min(1).max(PLATFORM_ENDPOINT_LOCAL_NAME_MAX_LENGTH),
});
export const updatePlatformEndpointLocalNameResponseSchema = z.object({
    platformEndpointId: apiIntIdSchema,
    localName: z.string().min(1),
});
//# sourceMappingURL=platform-endpoint-contracts.js.map